<button class="heading-menu" [matMenuTriggerFor]="roles">Filter Roles <i class="fas fa-fw fa-caret-right"></i></button>
<mat-menu #roles="matMenu" class="p-3">
  <div class="permission-label" *ngFor="let group of availableGroups">
    <mat-checkbox [checked]="isChecked(group)" (change)="setSelection($event, group)">{{group.niceName}}</mat-checkbox>
  </div>
  <div>
    <a class="btn btn-outline-secondary btn-sm small float-right" (click)="clearSelection()">Clear Selection</a>
  </div>
</mat-menu>
